import React, { useState, useEffect } from "react"
import { FabricJSCanvas, useFabricJSEditor } from "fabricjs-react"
import axios from "axios"
import {
  Modal,
  ModalHeader,
  ModalBody,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap"
import Loader from "common/Loader"

const SavedDesign = ({canvasData}) => {
  const [design, setDesign] = useState()
  const [designX, setDesignX] = useState()
  const [designOptions, setDesignOptions] = useState([])
  const [selectedDesignId, setSelectedDesignId] = useState("")
  const [isModalOpen, setIsModalOpen] = useState(false)

  const apiBaseUrl = process.env.REACT_APP_APIBASE_URL
  let apiToken = JSON.parse(localStorage.getItem("authUser"))

  const { editor, onReady } = useFabricJSEditor()

  useEffect(() => {
    if (editor && design) {
      editor.canvas.loadFromJSON(design, () => {
        editor.canvas.setHeight(100)
        editor.canvas.setWidth(100)

        editor.canvas.forEachObject(obj => {
          obj.set({
            selectable: false,
            lockMovementX: true,
            lockMovementY: true,
            lockScalingX: true,
            lockScalingY: true,
            lockRotation: true,
            preserveAspectRatio: 'none', 
            scaleX: 0.3, // Adjust as needed
             scaleY: 0.3, // Adjust as needed
          })
        })

        editor.canvas.renderAll()
      })
    }
  }, [editor, design])



  const [selectedDesignName, setSelectedDesignName] = useState("")

 

  const downloadCanvas = async () => {
    const dataURL = editor.canvas.toDataURL({
      format: "png",
      quality: 1,
      multiplier: 2,
      enableRetinaScaling: true,
    })
    const blob = await fetch(dataURL).then(res => res.blob())
    console.log(blob)
    const a = document.createElement("a")
    a.href = dataURL
    a.download = "canvas_image.png"
    document.body.appendChild(a)
    a.click()

    await axios({
      method: "POST",
      url: `${apiBaseUrl}/MarketingToolLog`,
      data: {
        user_id: localStorage.getItem("id"),
        File: a.download,
      },
      headers: { Authorization: apiToken },
    })
      .then(res => {
        document.body.removeChild(a)
      })
      .catch(err => {
        console.log(err)
      })

    return dataURL
  }


  useEffect(() => {
   setDesign(JSON.parse(canvasData))
  }, [canvasData])
  


  return (
    <div className="d-flex justify-content-center align-items-center">
      <FabricJSCanvas onReady={onReady} />
    </div>
   
  )
}

export default SavedDesign
